import { useState } from 'react';
import { LoaderBar } from '../../../../../../components';
import { SortedWaveListHook } from '../../../../../../hooks';
import { SortedSingleAntTable } from '../../../../../../page-components';
import { OrderService, ToastMessage } from '../../../../../../utility';

export function SingleTab({ warehouseId }) {
  const { data, totalData, loading, filter, filterChanged, pageChanged, refresh } =
    SortedWaveListHook(warehouseId);

  const [processing, setProcessing] = useState(false);

  const fulfillOrder = async item => {
    try {
      setProcessing(true);
      const payload = {
        allocations: [
          {
            quantity: item.quantity,
            allocationId: item.id,
          },
        ],
      };
      await OrderService.fulfillTote(item.order?.id, payload);
      ToastMessage.success('Order marked as fulfilled Successfully');
      refresh();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="position-relative pt-4">
      {processing && <LoaderBar />}
      <SortedSingleAntTable
        loading={loading}
        data={data || []}
        totalData={totalData}
        filter={filter}
        filterChanged={filterChanged}
        pageChanged={pageChanged}
        fulfillOrder={fulfillOrder}
      />
    </div>
  );
}
